import { render } from "./CreateProject.vue?vue&type=template&id=5e7d009c&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=5e7d009c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7d009c"]])

export default __exports__